import { render, staticRenderFns } from "./AppBindezHeaderLogo.vue?vue&type=template&id=7813f915&scoped=true&"
import script from "./AppBindezHeaderLogo.vue?vue&type=script&lang=js&"
export * from "./AppBindezHeaderLogo.vue?vue&type=script&lang=js&"
import style0 from "./AppBindezHeaderLogo.vue?vue&type=style&index=0&id=7813f915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7813f915",
  null
  
)

export default component.exports